// Components
export { default as AnnotationCanvas } from "./components/AnnotationCanvas";
export { default as AnnotationEditor } from "./components/AnnotationEditor";
export { AnnotationList } from "./components/AnnotationList";
export { AnnotationItem } from "./components/AnnotationItem";

// Stores
export { useAnnotationStore } from "./store/annotationStore";
export { useAnnotationEditorStore } from "./store/annotationEditorStore";

// Types
export type { EditorAnnotation } from "./store/annotationTypes";
export { EditorAnnotationType } from "./store/annotationTypes";

export type { MediaItem, AnnotationEditorProps } from "./components/AnnotationEditor";

// Enums and Constants
export { MarkupMode } from "./types";

// Utils
export { generateMediaKey } from "./utils/annotationUtils";
